import React, { useState, useCallback } from "react";
import { Button, Upload, Modal, Table } from "antd";
import {
  UploadOutlined,
  DeleteOutlined,
  CloudUploadOutlined,
} from "@ant-design/icons";
import JSZip from "jszip";
import moment from "moment";
import ExcelJS from "exceljs";
import { FaPlus } from "react-icons/fa6";
import { Alert, Tooltip } from "antd";
import xml2js from "xml2js";
import "./InventoryContainer.css";
import { notification } from "antd/lib";
import convertS3ToCloudFront from "../../../../utils/convertS3ToCloudFront";
import { useDispatch } from "react-redux";
import { addToCart } from "../../../toolkit/slices/cart/cartSlice";
import { Radio } from "antd";
import { useEffect } from "react";
import { Typography, Card, Input } from "antd";
import { Checkbox } from "antd";
import { Select } from "antd";
import "./trade.css";
import { MutatingDots } from "react-loader-spinner";
const { Option } = Select;
const { Title, Paragraph, Text } = Typography;
const Trade = ({ inventories, setInventories, setAddInventoryBoolean }) => {
  const dispatch = useDispatch();
  console.log("inv", inventories, setInventories);
  const [pptFile, setPPTFile] = useState(null);
  const [rates, setRates] = useState({});
  const [excelFile, setExcelFile] = useState(null);
  const [tradeModalVisible, setTradeModalVisible] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [pptImages, setPPTImages] = useState([]);
  const [pptText, setPPTText] = useState([]);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [value, setValue] = useState(null);
  const [finalLocation, setFInalLocation] = useState([]);
  const [pptToSend, setPpTSend] = useState();
  const [dataToMap, setDataToMap] = useState([]);
  const [checkedRecords, setCheckedRecords] = useState({});
  const [selectedValue, setSelectedValue] = useState(null);
  const [isFirstButtonDisabled, setIsFirstButtonDisabled] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [current, setCurrent] = useState(1); // State to keep track of current page
  const [pageSize, setPageSize] = useState(50); // State to keep track of page size
  const [showError, setshowError] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const handleTableChange = (pagination) => {
    setCurrent(pagination.current);
    setPageSize(pagination.pageSize);
  };
  const handleFilter = () => {
    const filteredRows = excelData
      .slice(1)
      .filter((rowData) => checkedRecords[rowData[0]]);
    setFilteredData([excelData[0], ...filteredRows]); // Include header row explicitly
  };
  const handleRefresh = () => {
    setExcelFile(excelData);
    setFilteredData(excelData);
  };
  const [options, setoptions] = useState([]);
  const [optionMedia, setoptionMedia] = useState([]);
  const [makeInfo, setMakeInfo] = useState(false);
  // const onChange = (e) => {
  //   console.log("radio checked", e.target.value);
  //   setValue(e.target.value);
  // };

  const handleChange = (value) => {
    setExcelData([]);
    setValue(value);
    setSelectedValue(value);
    setIsFirstButtonDisabled(false); // Enable the first button when an option is selected
    if (value === "others") {
      setMakeInfo(true);
    } else {
      setMakeInfo(false);
    }
    console.log("Selected value:", value);
    // Perform any additional actions you need when the selection changes
  };

  const getFilterOptions = (index, processedData) => {
    console.log("Index passed to getFilterOptions:", index);
    console.log("Processed Data:", processedData);

    // Map over the rows of data starting from the second row (excluding headers)
    const filteredData = processedData.slice(1).map((row) => row[index]);
    console.log("Filtered Data: & option", filteredData, options);

    return [...new Set(filteredData)]
      .filter((value) => typeof value === "string")
      .map((value) => ({
        value,
        label: value,
      }));
  };

  const filterDataByColumnName = useCallback(
    (value, columnName) => {
      const columnIndex = excelData[0].indexOf(columnName);
      if (columnIndex === -1) return; // Column not found
      const filteredRows = excelData
        .slice(1) // Exclude header
        .filter((rowData) => value.includes(rowData[columnIndex]));

      setFilteredData([excelData[0], ...filteredRows]); // Include header row explicitly
    },
    [excelData],
  );

  const handleFilterChange = (value) => {
    // const index = selectedValue === "chitra" ? 5 : 2;
    let colName;
    if (selectedValue == "kaushik") {
      colName = "CITY/AREA";
    } else if (selectedValue == "chitra") {
      colName = "Area";
    } else if (selectedValue == "evergreen" || selectedValue == "aim") {
      colName = "Type";
    } else if (selectedValue == "abhik" || selectedValue == "mantra") {
      colName = "Area";
    } else if (selectedValue == "saket") {
      colName = "AREA";
    } else if (selectedValue == "priya") {
      colName = "Town";
    } else if (
      selectedValue == "sitemax" ||
      selectedValue == "shah" ||
      selectedValue == "shubham"
    ) {
      colName = "City";
    }
    // else if(selectedValue ==)
    filterDataByColumnName(value, colName);
  };

  const handleFiltereeChange = (value) => {
    let colName;
    if (selectedValue == "kaushik" || selectedValue == "sun") {
      colName = "MEDIA";
    }
    if (selectedValue == "mantra") {
      colName = "Media Type";
    }
    console.log("Calling from media", colName, value);
    filterDataByColumnName(value, colName);
  };
  // const options = selectedValue === "chitra"
  //   ? getFilterOptions(5)
  //   : getFilterOptions(2);

  const valueToIndexKeyMap = {
    kaushik: "SR NO",
    chitra: "Sr",
    sun: "No.",
    mantra: "Sr",
    priya: "Sr",
    saket: "NO.",
    abhik: "Sr",
    sitemax: "Sr",
    shah: "Sr. No",
    shubham: "Sr. No.",
    aim: "Sr",
    others: "srNo",
    // Add other mappings here
  };

  const handleTradeOk = async () => {
    try {
      console.log("This is the excel data from trade", excelData);
      console.log("This is the dataToMap from trade", dataToMap);

      for (let index = 0; index < excelData.length - 1; index++) {
        let rpm = 0;
        const row = excelData[index + 1]; // Adjusting for header row

        const srNo = row[0];
        if (
          (checkedRecords[srNo] && !checkedRecords[srNo]) ||
          typeof checkedRecords[srNo] === "undefined"
        ) {
          continue;
        }
        if (rates[srNo]) {
          console.log("This is the ratesss", rates);
          rpm = rates[srNo];
        }

        var locationColumnIndex;
        if (value === "kaushik") {
          locationColumnIndex = excelData[0].indexOf("LOCATION");
        } else if (value === "chitra") {
          locationColumnIndex = excelData[0].indexOf("Location");
        }

        if (locationColumnIndex === -1) {
          notification.error({
            message: "LOCATION column not found in the Excel data",
          });
          continue;
        }

        const location = row[locationColumnIndex];
        // const transformedLocation = transformLocation(location);

        const rowData = row.reduce((acc, valueRow, idx) => {
          const header = excelData[0][idx];
          console.log("Printinggggg", header);
          if (
            (/LONGITUDE & LATITUDE/.test(header) && value == "kaushik") ||
            (/LAT-LONG/.test(header) && value == "saket")
          ) {
            console.log("Inside thissssss");
            const val = value == "kaushik" ? "&" : ",";
            const [latitude, longitude] = valueRow
              .split(val)
              .map((coord) => coord.trim());
            acc["lat"] = latitude;
            acc["lng"] = longitude;
          } else if (header === "LOCATION") {
            acc["name"] = valueRow;
          } else if (header === "Lat Long" && value == "sun") {
            const [latitude, longitude] = valueRow
              .split(",")
              .map((coord) => coord.trim());
            acc["lat"] = latitude;
            acc["lng"] = longitude;
          } else if (header == "SIZE") {
            const [W, H] = valueRow.split("X");
            acc["W"] = W;
            acc["H"] = H;
          } else {
            acc[header] = valueRow;
          }
          return acc;
        }, {});

        console.log("Row Data:sssss", rowData);
        console.log("Valueeeeeeeee", value);
        var imageUrl = "";
        const getTheIndex = valueToIndexKeyMap[value]
          ? rowData[valueToIndexKeyMap[value]]
          : null;

        // if (value === "kaushik" ) {
        console.log("Get The Index:", getTheIndex);
        console.log("Data Index:", getTheIndex - 1);

        if (getTheIndex > 0) {
          if (value == "others") {
            imageUrl = dataToMap[getTheIndex];
          } else {
            imageUrl = dataToMap[getTheIndex - 1];
            console.log("Image URL:", imageUrl);
          }
        }
        // }
        // else {
        //   imageUrl = dataToMap.find(
        //     (obj) => Object.keys(obj)[0] === transformedLocation
        //   )?.[transformedLocation];
        //   console.log("Image URL:", imageUrl);
        // }

        if (!imageUrl) {
          imageUrl =
            "https://prepseed.s3.ap-south-1.amazonaws.com/loaderImage.png";
        }

        var requestBody;
        if (value === "kaushik") {
          const dateStr = rowData["AVAILABILITY"];
          const [day, month, year] = dateStr.split(".");
          const formattedDate = `20${year}-${month}-${day}`;
          const dateObject = new Date(formattedDate);
          console.log("Rate to checkkkkkk", rowData.RATE);
          requestBody = {
            locations: {
              city: rowData["CITY/AREA"],
              Area: rowData.ZONE ? rowData.ZONE : "Ahmedabad",
              name: rowData["CITY/AREA"],
            },
            Illu: rowData.TYPE,
            typeOfMedia: rowData.MEDIA,
            width: rowData.WIDTH,
            height: rowData.HEIGHT,
            vendor: value,
            CodeNo: rowData["ID NO"],
            CASCode: "123",
            img: imageUrl,
            lat: parseFloat(rowData.lat),
            lng: parseFloat(rowData.lng),
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            PurchaseRate: rowData.RATE,
            AvailableForTrade: dateObject,
            ownedBy: value,
            Availability:
              rowData["AVAILABILITY"] == "Available"
                ? "Immediate"
                : rowData["AVAILABILITY"],
          };

          console.log("This is the req body", requestBody);
        } else if (value === "chitra") {
          requestBody = {
            locations: {
              city: rowData.City,
              Area: rowData.Area,
              name: rowData.Location,
            },
            Illu: rowData.Light,
            typeOfMedia: "Billboard",
            width: rowData.W,
            height: rowData.H,
            vendor: value,
            CodeNo: rowData["HID"],
            CASCode: "456",
            img: imageUrl,
            lat: parseFloat(rowData.Latitude),
            lng: parseFloat(rowData.Longitude),
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["Net Rate P.M."],
            Availability:
              rowData["Available From"] == "Available Now"
                ? "Immediate"
                : rowData["Available From"],
          };
        } else if (value === "sun") {
          requestBody = {
            locations: {
              city: "No",
              Area: "No",
              name: rowData.Location,
            },
            Illu: rowData.Type,
            typeOfMedia: "Gantry",
            width: rowData.W,
            height: rowData.H,
            vendor: value,
            CodeNo: "789",
            CASCode: "789",
            img: imageUrl,
            lat: parseFloat(rowData.lat),
            lng: parseFloat(rowData.lat),
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["Rate p.m."],
            Availability:
              rowData["Date"] == "Immediate" ? "Immediate" : rowData["Date"],
          };
        } else if (value === "mantra") {
          requestBody = {
            locations: {
              city: "No",
              Area: rowData.Area,
              name: rowData.Location,
            },
            Illu: rowData.Light,
            typeOfMedia: rowData["Media Type"] || rowData["Light"],
            width: rowData.W,
            height: rowData.H,
            vendor: value,
            CodeNo: rowData.IID,
            CASCode: "101112",
            img: imageUrl,
            lat: "0.0",
            lng: "0.0",
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["Discounted Monthly Rate"],
            Availability:
              rowData["Available From"] == "Available Now"
                ? "Immediate"
                : rowData["Available Now"],
          };
        } else if (value === "shah") {
          requestBody = {
            locations: {
              city: "No",
              Area: "No",
              name: rowData.Location,
            },
            Illu: rowData.Type,
            typeOfMedia: rowData["Media"],
            width: rowData.W,
            height: rowData.H,
            vendor: value,
            CodeNo: "131415",
            CASCode: "131415",
            img: imageUrl,
            lat: "0.0",
            lng: "0.0",
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["Ad Space Charges Per Month"],
            Availability:
              rowData["Status"] == "Available"
                ? "Immediate"
                : rowData["Status"],
          };
        } else if (value === "sitemax") {
          requestBody = {
            locations: {
              city: rowData.City,
              Area: "No",
              name: rowData.Location,
            },
            Illu: rowData.Light,
            typeOfMedia: "Billboard",
            width: rowData.W,
            height: rowData.H,
            vendor: value,
            CodeNo: rowData["HID"],
            CASCode: "131415",
            img: imageUrl,
            lat: "0.0",
            lng: "0.0",
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["Monthly Rate"],
            Availability:
              rowData["Available From"] == "Available Now"
                ? "Immediate"
                : rowData["Available From"],
          };
        } else if (value === "priya") {
          requestBody = {
            locations: {
              city: "No",
              Area: rowData.Town,
              name: rowData.Locations,
            },
            Illu: rowData.Type,
            typeOfMedia: "Billboard",
            width: rowData.W,
            height: rowData.H,
            vendor: value,
            CodeNo: "161718",
            CASCode: "161718",
            img: imageUrl,
            lat: rowData.Latitude,
            lng: rowData.Longitude,
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["Net Rate P.M. Rs."],
            Availability: rowData["Availability"],
          };
        } else if (value === "saket") {
          console.log("Row DATA", rowData);
          requestBody = {
            locations: {
              city: "No",
              Area: rowData.AREA,
              name: rowData.name,
            },
            Illu: rowData.TYPE,
            typeOfMedia: "Billboard",
            width: rowData.W,
            height: rowData.H,
            vendor: value,
            CodeNo: "192021",
            CASCode: "192021",
            img: imageUrl,
            lat: rowData.lat,
            lng: rowData.lng,
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["RATE"],
            Availability: rowData["AVAILABILITY"],
          };
        } else if (value === "abhik") {
          requestBody = {
            locations: {
              city: rowData["City"],
              Area: rowData.Area,
              name: rowData.Location,
            },
            Illu: rowData.Light,
            typeOfMedia: "Billboard",
            width: rowData.W,
            height: rowData.H,
            vendor: value,
            CodeNo: rowData["HID"],
            CASCode: "222324",
            img: imageUrl,
            lat: rowData.lat,
            lng: rowData.lng,
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["Monthly Rate"],
            Availability:
              rowData["Available From"] == "Available Now"
                ? "Immediate"
                : rowData["Available From"],
          };
        } else if (value === "evergreen") {
          requestBody = {
            locations: {
              city: "No",
              Area: "No",
              name: rowData.Location,
            },
            Illu: rowData.Type,
            typeOfMedia: "Billboard",
            width: rowData.W,
            height: rowData.H,
            vendor: value,
            CodeNo: "252627",
            CASCode: "252627",
            img: imageUrl,
            lat: rowData.Latitude,
            lng: rowData.Longitude,
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["Rental"],
            Availability: rowData["Status"],
          };
        } else if (value === "shubham") {
          requestBody = {
            locations: {
              city: "No",
              Area: "No",
              name: rowData.Location,
            },
            Illu: rowData.Type,
            typeOfMedia: "Billboard",
            width: rowData.W,
            height: rowData.H,
            vendor: value,
            CodeNo: "282930",
            CASCode: "282930",
            img: imageUrl,
            lat: rowData.Latitude,
            lng: rowData.Longitude,
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["Net Rate Per Month"],
            Availability: rowData["Available Date"],
          };
        } else if (value === "aim") {
          requestBody = {
            locations: {
              city: "No",
              Area: "No",
              name: rowData.Location,
            },
            Illu: rowData.Type,
            typeOfMedia: "Billboard",
            width: rowData.W,
            height: rowData.H,
            vendor: value,
            CodeNo: "313233",
            CASCode: "313233",
            img: imageUrl,
            lat: rowData.Latitude,
            lng: rowData.Longitude,
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["Rate Per Month"],
            Availability: rowData["Available Date"],
          };
        } else if (value == "others") {
          requestBody = {
            locations: {
              city: rowData.City || rowData.city,
              Area: rowData.Area || rowData.area,
              name: rowData.Location || rowData.location,
            },
            Illu: rowData.Type,
            typeOfMedia: "Billboard",
            width: rowData.width || rowData.Width,
            height: rowData.height || rowData.Height,
            vendor: value,
            CodeNo: "635365",
            CASCode: "635365",
            img: imageUrl,
            lat: rowData.Latitude || rowData.latitude,
            lng: rowData.Longitude || rowData.longitude,
            unit: 1,
            isTrading: true,
            ratePerMonth: rpm,
            ownedBy: value,
            PurchaseRate: rowData["Buying Cost"],
            Availability: rowData["Availability"],
          };
        }

        console.log("Request Body:", requestBody);

        try {
          const inventoryResponse = await fetch(
            `${apiBaseUrl}/inventoryManagement`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization: `Token ${window.localStorage.getItem("token")}`,
              },
              body: JSON.stringify(requestBody),
            },
          );

          if (inventoryResponse.ok) {
            const responseData = await inventoryResponse.json();
            const newInventory = responseData.inventory;

            // Dispatch addToCart action here
            dispatch(addToCart(newInventory));
            console.log("Inventory added:", newInventory);
          } else {
            console.log(
              "Error occurred:",
              inventoryResponse.status,
              inventoryResponse.statusText,
            );
            const responseData = await inventoryResponse.json();
            const newInventory = responseData.existingInventory;

            // Dispatch addToCart action here
            dispatch(addToCart(newInventory));
            console.log("Inventory added:", newInventory);
          }
        } catch (error) {
          console.log("Error during inventory insertion:", error.message);
        }
      }

      setAddInventoryBoolean(false);
    } catch (error) {
      console.log("Error during handleTradeOk execution:", error.message);
      setAddInventoryBoolean(false);
    }
  };

  const handleButtonClick = () => {
    console.log("Going inside this");
    if (dataToMap.length == 0) {
      notification.error({ message: "Please upload images" });
      return;
    }
    handleTradeOk(); // Call handleTradeOk when the button is clicked
  };

  const handleTradeCancel = () => {
    setTradeModalVisible(false);
  };

  const handleExcelUpload = async (info) => {
    try {
      let processedData = [];
      setDataToMap([]);
      setFilteredData([]);
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1); // Limit to one file
      const file = fileList[0]?.originFileObj;
      setExcelFile(fileList[0]);
      if (!file.name.endsWith("xlsx")) {
        notification.error({
          message: "Files other than .xlsx are not allowed",
        });
        setFilteredData(excelData);
        setExcelFile(excelData);
        return;
      }

      if (file) {
        const workbook = new ExcelJS.Workbook();
        const reader = new FileReader();

        reader.onload = async (e) => {
          const buffer = e.target.result;
          await workbook.xlsx.load(buffer);

          let worksheet = workbook.worksheets[0];
          const data = [];
          const locations = [];
          let locationColumnIndex = null;
          let latitudeLongitudeColumnIndex = null;
          let availabilityColumnIndex = null; // Added to track the Availability column
          let startRow = 1; // Default startRow value
          console.log("Worksheet", worksheet);

          // Find the row index where the 'srno' is located using a for loop
          for (
            let rowNumber = 1;
            rowNumber <= worksheet.rowCount;
            rowNumber++
          ) {
            const row = worksheet.getRow(rowNumber);
            if (
              row.values.includes("Sr") ||
              row.values.includes("Srno") ||
              row.values.includes("SR") ||
              row.values.includes("No") ||
              row.values.includes("Sr. No.") ||
              row.values.includes("Sr. No") ||
              row.values.includes("NO.")
            ) {
              if (value === "priya") {
                startRow = rowNumber + 1;
              } else {
                startRow = rowNumber;
              }
              break; // Break the loop once the startRow is found
            }
          }

          // Find the column indices based on the header row
          const headerRow = worksheet.getRow(startRow);
          console.log("HeadersRow:", headerRow);
          const headers = headerRow.values
            .slice(1)
            .map((header) => header.trim()); // Skip the first empty value
          console.log("Headers:", headers);

          headers.forEach((header, colNumber) => {
            if (
              (value == "kaushik" && header === "LOCATION") ||
              (value == "chitra" && header === "Location") ||
              (value == "sun" && header === "Location")
            ) {
              locationColumnIndex = colNumber; // Adjust for zero-based index
            }

            if (header == "LONGITUDE & LATITUDE") {
              latitudeLongitudeColumnIndex = colNumber; // Adjust for zero-based index
            }
            if (header == "Lat Long") {
              latitudeLongitudeColumnIndex = colNumber;
            }
            if (
              (header == "Availability" || header == "AVAILABILITY") &&
              (value == "priya" || value == "saket")
            ) {
              // Added to identify Availability column
              availabilityColumnIndex = colNumber;
            }
          });
          console.log("Here are the headers", headers);

          // Save headers to data array
          data.push(headers);

          worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
            if (rowNumber <= startRow) return; // Skip rows before and including the startRow

            const rowData = row.values.slice(1); // Skip the first empty value
            console.log("This is the rowwww data", rowData);
            const cleanedRowData = rowData.map((value, index) => {
              if (index === availabilityColumnIndex) {
                console.log("this is f ", value, typeof value);
                if (typeof value === "object") {
                  const date = moment(value);
                  if (date.isValid()) {
                    return date.format("DD/MM/YYYY");
                  }
                }
                return value; // Return "Immediate" or the original string if it's not a valid date
              }
              console.log("this is f hhahahah ", value, typeof value);
              if (typeof value == "date" || typeof value == "object") {
                if (value && value.hasOwnProperty("result")) {
                  return value.result;
                }
                const date = moment(value);
                if (date.isValid()) {
                  return date.format("DD/MM/YYYY");
                }
              }
              if (value && typeof value === "object") {
                return value.result || value.text || ""; // Extract result, fallback to text if available
              }

              if (index === latitudeLongitudeColumnIndex) {
                // Check if the cell contains a hyperlink object
                if (value && typeof value === "object" && value.text) {
                  return value.text;
                }
              }

              return value;
            });

            // Extract and transform LOCATION column value
            const location = rowData[locationColumnIndex];
            if (location) {
              const transformedLocation = transformLocation(location);
              cleanedRowData.push(transformedLocation);
              locations.push(transformedLocation);
            }

            // Check Availability column and handle dates
            if (availabilityColumnIndex !== null) {
              const availabilityValue = rowData[availabilityColumnIndex];
              if (availabilityValue) {
                console.log("Availability:", availabilityValue); // Log the availability value for debugging
              }
            }

            // Check if cleanedRowData contains any non-null, non-empty values
            if (
              cleanedRowData.some((value) => value !== null && value !== "")
            ) {
              data.push(cleanedRowData);
            }
          });

          setFInalLocation(locations);
          console.log("this is the data for othersssssssss", data);
          // Use a for loop to traverse and process each item
          for (let i = 0; i < data.length; i++) {
            const item = data[i];
            // Check if any cell in the row contains "Terms" and break the loop if found
            if (
              item.some(
                (cell) => typeof cell === "string" && /terms/i.test(cell),
              ) ||
              item.some(
                (cell) => typeof cell === "string" && /Note/i.test(cell),
              ) ||
              item.some(
                (cell) => typeof cell === "string" && /Public Link/i.test(cell),
              ) ||
              item.some(
                (cell) => typeof cell === "string" && /Map view/i.test(cell),
              ) ||
              item.some(
                (cell) =>
                  typeof cell === "object" &&
                  /Click here for Map view!/i.test(cell.text),
              )
            ) {
              // Store the data up to this point
              processedData = data.slice(0, i);
              break;
            }
          }
          if (processedData.length == 0) {
            processedData = data;
            console.log("coming from pd", data);
          }
          let indexOfLocation = -1;
          let indexOfMedia = -1;
          // Log the processed data
          console.log("Processed Data:", processedData[0]);
          setExcelData(processedData);

          if (
            (selectedValue === "kaushik" || selectedValue == "sun") &&
            processedData.length > 0
          ) {
            // Ensure that excelData is not empty and the first row exists
            indexOfLocation = processedData[0].findIndex(
              (column) => column === "CITY/AREA",
            );
            indexOfMedia = processedData[0].findIndex(
              (column) => column.toLowerCase() === "media",
            );
          } else if (selectedValue === "chitra") {
            indexOfLocation = processedData[0].findIndex(
              (column) => column === "Area",
            );
          } else if (selectedValue === "evergreen" || selectedValue == "aim") {
            indexOfLocation = processedData[0].findIndex(
              (column) => column === "Type",
            );
          } else if (selectedValue == "abhik") {
            indexOfLocation = processedData[0].findIndex(
              (col) => col == "Area",
            );
          } else if (selectedValue == "saket" || selectedValue == "mantra") {
            indexOfLocation = processedData[0].findIndex(
              (col) => col.toLowerCase() == "area",
            );
            indexOfMedia =
              value == "mantra"
                ? processedData[0].findIndex((col) => col == "Media Type")
                : -1;
            console.log("Going inside this", indexOfMedia, indexOfLocation);
          } else if (selectedValue == "priya") {
            indexOfLocation = processedData[0].findIndex(
              (col) => col == "Town",
            );
          } else if (
            selectedValue == "sitemax" ||
            selectedValue == "shah" ||
            selectedValue == "shubham"
          ) {
            indexOfLocation = processedData[0].findIndex(
              (col) => col == "City",
            );
          }
          // else {
          //   indexOfLocation = processedData[0].findIndex((col) => col == "Area");
          // }
          if (indexOfLocation != -1) {
            let options = getFilterOptions(indexOfLocation, processedData);
            console.log("lllll", options);
            setoptions(options);
          }
          if (indexOfMedia != -1) {
            let options = getFilterOptions(indexOfMedia, processedData);
            setoptionMedia(options);
          }
        };
        reader.readAsArrayBuffer(file);
      }
    } catch (error) {
      notification.error({
        message:
          "Something went wrong Check the excel value or the vendor you selected",
      });
    }
  };

  const handleExcelDelete = () => {
    setExcelFile([]);
    setExcelData([]);
    setFilteredData([]);
    setExcelFile([]);
    setDataToMap([]);
    setoptions([]);
    setoptionMedia([]);
    setCheckedRecords([]);
    setRates([]);
    setSelectedValue(null);
    setValue(null);
    setIsFirstButtonDisabled(true);
    setMakeInfo(false);
    // setIsSecondButtonDisabled(true);
  };

  const handlePPTUploadFInal = async (info) => {
    setshowError(false);
    setDataToMap([]);
    setIsUploading(true);

    try {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1); // Limit to one file
      const file = fileList[0]?.originFileObj;
      if (!file) {
        throw new Error("No file selected");
      }

      const filename = file.name;
      const typeOfFile = file.type;
      const mime = typeOfFile.split("/")[1];

      const requestBody = {
        fileName: filename,
        mime: mime,
      };
      // Step 1: Fetch upload policy
      // Example adjusting ACL for public-read
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/uploadPolicy`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            fileName: filename,
            mime,
            ACL: "public-read",
          }), // Include ACL in request body
        },
      );
      // if(response.ok){
      //   setIsUploading(false);
      // }
      if (!response.ok) {
        throw new Error(
          `Failed to fetch upload policy: ${response.status} ${response.statusText}`,
        );
      }

      const data = await response.json();

      // Step 2: Prepare formData and upload file
      const formData = new FormData();

      // Set Content-Type to ensure it matches S3 policy requirements
      const contentType =
        file.type ||
        "application/vnd.openxmlformats-officedocument.presentationml.presentation";

      for (const [key, value] of Object.entries(data.data.fields)) {
        // Override Content-Type if present to ensure exact match
        if (key.toLowerCase() === "content-type") {
          formData.set(key, contentType);
        } else {
          formData.set(key, value);
        }
      }

      // Ensure Content-Type is set even if not in fields
      if (!formData.has("Content-Type") && !formData.has("content-type")) {
        formData.set("Content-Type", contentType);
      }

      formData.append("file", file);

      const finalUrl = convertS3ToCloudFront(
        `${data.data.url}/${data.filePath}`,
      );

      // Step 3: Upload file
      const almostFinalResponse = await fetch(data.data.url, {
        method: "POST",
        body: formData,
      });

      if (true) {
        console.log("File uploaded successfully!");
        console.log("Final URL:", finalUrl);
        setPpTSend(finalUrl);
        const requestBody = {
          client: value,
          url: finalUrl,
        };
        try {
          const response = await fetch(
            "https://0e5necj9dj.execute-api.ap-south-1.amazonaws.com/extract_image_and_location_from_pptx",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization: `Token ${window.localStorage.getItem("token")}`,
              },
              body: JSON.stringify(requestBody),
            },
          );

          if (!response.ok) {
            setIsUploading(false);
            notification.error({
              message: "Some error occured while get Image contact sanket",
            });
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const data = await response.json();
          // if (data.length != excelData.length - 1 && showError === false) {
          //   setIsUploading(false);
          //   notification.info({
          //     message: "The length of excel and ppt should be the same",
          //   });
          //   setshowError(true);
          //   return;
          // }
          setDataToMap(data);
          console.log("API Response:", data.length);
          setIsUploading(false);
          // Further processing of the API response
        } catch (error) {
          console.error("Error occurred during fetch:", error.message);
          // Handle error, show notification, etc.
        }
      } else {
        throw new Error(
          `Failed to upload file: ${almostFinalResponse.status} ${almostFinalResponse.statusText}`,
        );
      }
    } catch (error) {
      console.error("Error occurred during file upload:", error.message);
      // Handle error, show notification, etc.
    }
  };

  const handlePPTUpload = (info) => {
    console.log("Coming from ppt", finalLocation);
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1); // Limit to one file
    const file = fileList[0]?.originFileObj;
    setPPTFile(fileList[0]);
    if (!file.name.endsWith("pptx")) {
      notification.error({
        message: "File other then pptx extension are not allowed ",
      });
      // setPPTFile(null);
      return;
    }
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const zip = await JSZip.loadAsync(e.target.result);
        const imagePromises = [];
        const textPromises = [];

        // Extracting images and texts from slides
        for (const relativePath in zip.files) {
          // Extract image
          if (relativePath.startsWith("ppt/media/")) {
            const file = zip.files[relativePath];
            imagePromises.push(
              file
                .async("blob")
                .then((blob) => {
                  return {
                    blob,
                    relativePath,
                  };
                })
                .catch((error) => {
                  console.error("Error extracting image:", error);
                  throw error; // Rethrow error to propagate to the catch block
                }),
            );
          }

          // Extract text
          if (relativePath.startsWith("ppt/slides/slide")) {
            const file = zip.files[relativePath];
            textPromises.push(
              file
                .async("text")
                .then((xml) => xml2js.parseStringPromise(xml))
                .catch((error) => {
                  console.error("Error extracting text:", error);
                  throw error; // Rethrow error to propagate to the catch block
                }),
            );
          }
        }

        try {
          // Resolve image promises
          const images = await Promise.all(imagePromises);
          const pptImages = images.map((img) => URL.createObjectURL(img.blob));
          setPPTImages(pptImages);

          // Resolve text promises
          const texts = await Promise.all(textPromises);
          const extractedText = texts.map((textObj) => {
            const text = [];
            const extractTextFromNode = (node) => {
              if (node["a:t"]) {
                text.push(node["a:t"].join(" "));
              }
              for (const key in node) {
                if (typeof node[key] === "object") {
                  extractTextFromNode(node[key]);
                }
              }
            };
            extractTextFromNode(textObj);
            return text.join(" ");
          });

          setPPTText(extractedText);
        } catch (error) {
          console.error("Error processing PPTX file:", error);
        }
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const handlePPTDelete = () => {
    setDataToMap([]);
  };
  const transferedLocations = [
    {
      prahladnagarnrseemahalltowprahladnagargardendown:
        "https://prepseed.s3.ap-south-1.amazonaws.com/prod/ldoc/inventoryManagement/slide_1_shape_1_20240718120506.jpeg",
    },
    {
      satelliteroadnrisrotowisconcircleoppsundarvan:
        "https://prepseed.s3.ap-south-1.amazonaws.com/prod/ldoc/inventoryManagement/slide_2_shape_1_20240718120507.jpeg",
    },
    {
      satelliteshivranjaniobtowshyamalfcgkeshavbaug:
        "https://prepseed.s3.ap-south-1.amazonaws.com/prod/ldoc/inventoryManagement/slide_3_shape_1_20240718120507.jpeg",
    },
  ];
  const transformLocation = (location) => {
    if (typeof location === "string") {
      return location
        .replace(/[^\w\s]|_/g, "") // Remove punctuation
        .replace(/\s+/g, "") // Remove spaces
        .toLowerCase(); // Convert to lowercase
    }
    return ""; // Return an empty string or handle the case when location is not a string
  };

  const handleCheckBoxChange = (e, rowData) => {
    const { checked } = e.target;
    if (rowData === "all") {
      const updatedCheckedRecords = excelData.slice(1).reduce((acc, data) => {
        acc[data[0]] = !excelData
          .slice(1)
          .every((rowData) => checkedRecords[rowData[0]]);
        return acc;
      }, {});
      setCheckedRecords(updatedCheckedRecords);
    } else {
      setCheckedRecords({
        ...checkedRecords,
        [rowData[0]]: checked,
      });
    }
  };
  useEffect(() => {}, [excelData]);

  const handleRateChange = (e, record) => {
    const newRate = e.target.value;
    const srNo = record[0]; // Assuming the first column is the serial number

    // Update the rate in the rates state
    setRates((prevRates) => ({
      ...prevRates,
      [srNo]: newRate,
    }));
    console.log("Set ratesss", rates);
  };
  const columns =
    excelData.length > 0
      ? [
          {
            title: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "15px",
                }}
              >
                <Checkbox
                  style={{ marginRight: 8 }} // Add some spacing between the checkbox and the text
                  onChange={(e) => handleCheckBoxChange(e, "all")}
                  checked={
                    Object.values(checkedRecords).length > 0 &&
                    Object.values(checkedRecords).every(
                      (isChecked) => isChecked,
                    )
                  }
                />
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleCheckBoxChange({ target: { checked: null } }, "all")
                  }
                >
                  Select
                </span>
              </div>
            ),
            key: "select",
            render: (_, rowData) => (
              <Checkbox
                onChange={(e) => handleCheckBoxChange(e, rowData)}
                checked={!!checkedRecords[rowData[0]]} // Ensure it's false by default
                style={{ fontSize: "15px" }}
              />
            ),
          },
          ...excelData[0].map((item, index) => {
            if (item === "RATE" && value === "kaushik") {
              return {
                title: <div style={{ fontSize: "15px" }}>BUYING RATE</div>,
                dataIndex: index,
                key: index,
                render: (text) => (
                  <div style={{ fontSize: "15px" }}>{text}</div>
                ),
              };
            } else if (/loca/i.test(item)) {
              return {
                title: <div style={{ fontSize: "15px" }}>{item}</div>,
                dataIndex: index,
                key: index,
                width: "300px",
                render: (text) => (
                  <div style={{ fontSize: "15px" }}>{text}</div>
                ),
              };
            }
            return {
              title: <div style={{ fontSize: "15px" }}>{item}</div>,
              dataIndex: index,
              key: index,
              render: (text) => <div style={{ fontSize: "15px" }}>{text}</div>,
            };
          }),
          {
            title: <div style={{ fontSize: "15px" }}>Rate per month</div>,
            key: "ratePerMonth",
            render: (_, record) => (
              <Input
                value={rates[record[0]] || ""}
                style={{ height: "20px", fontSize: "15px" }}
                onChange={(e) => handleRateChange(e, record)}
              />
            ),
          },
          {
            title: <div style={{ fontSize: "15px" }}>Image</div>,
            key: "image",
            render: (_, record) => {
              const srNo = record[0]; // Assuming record[0] holds the serial number

              if (!dataToMap || !Array.isArray(dataToMap)) {
                return null;
              }

              const imageUrl = dataToMap[srNo - 1]; // Get the corresponding image URL based on srNo

              return (
                <div>
                  {imageUrl ? (
                    // If the image exists, show it
                    <div>
                      <img
                        src={imageUrl}
                        alt={`Image ${srNo}`}
                        style={{
                          width: 50,
                          height: 50,
                          objectFit: "cover",
                          marginBottom: 10,
                        }}
                      />
                      {setIsUploading(false)}
                    </div>
                  ) : (
                    // If no image exists, show an upload button
                    <Tooltip title="Upload Image">
                      <Upload
                        beforeUpload={(file) => {
                          handleImageUpload(srNo, file); // Use the file directly from beforeUpload
                          return false; // Prevent auto-upload to handle manually
                        }}
                        showUploadList={false}
                      >
                        <Button
                          icon={<CloudUploadOutlined />}
                          style={{ width: "50px" }}
                        ></Button>
                      </Upload>
                    </Tooltip>
                  )}
                </div>
              );
            },
          },
        ]
      : [];

  const handleImageUpload = async (srNo, file) => {
    if (!file) {
      console.error("No file provided.");
      return;
    }

    console.log("This is the file:", file);

    // Get the file extension
    const fileExtension = file.name.split(".").pop();

    // Generate a random file name
    const randomFileName = `${Date.now()}_${Math.random().toString(36).substring(2, 15)}.${fileExtension}`;
    console.log("Generated filename:", randomFileName);

    // Prepare the request body for the policy
    const requestedBody = {
      fileName: randomFileName, // Send as 'fileName' to match API
      mime: file.type,
    };
    console.log("Request body:", requestedBody);

    try {
      // Request an upload policy from the server
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/uploadPolicyForEmails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestedBody),
        },
      );

      const data = await response.json();
      console.log("API Response:", data);

      // Check the response structure
      if (!data || !data.data || !data.data.fields) {
        console.error("Invalid response structure:", data);
        return;
      }

      // Prepare form data for file upload
      const formData = new FormData();

      // Set Content-Type to ensure it matches S3 policy requirements
      const contentType = file.type || "image/jpeg";

      for (const [key, value] of Object.entries(data.data.fields)) {
        // Override Content-Type if present to ensure exact match
        if (key.toLowerCase() === "content-type") {
          formData.set(key, contentType);
        } else {
          formData.set(key, value);
        }
      }

      // Ensure Content-Type is set even if not in fields
      if (!formData.has("Content-Type") && !formData.has("content-type")) {
        formData.set("Content-Type", contentType);
      }

      formData.append("file", file);

      // Construct the final URL
      const finalUrl =
        data.data.url && data.filePath
          ? convertS3ToCloudFront(`${data.data.url}/${data.filePath}`)
          : null;

      if (!finalUrl) {
        console.error("File path is undefined. Check the response structure.");
        return;
      }

      // Set the image URL (you can update the state or perform other actions here)
      setImageUrl(finalUrl);

      // Perform the file upload
      const uploadResponse = await fetch(data.data.url, {
        method: "POST",
        body: formData,
      });

      if (uploadResponse.ok) {
        console.log("File uploaded successfully!");

        setDataToMap((prevData) => {
          const updatedData = [...prevData]; // Copy previous data

          // Update only the image URL for the row corresponding to the `srNo`
          updatedData[srNo - 1] = finalUrl;

          return updatedData; // Return the updated array
        });
      } else {
        console.error(
          "File upload failed:",
          uploadResponse.status,
          uploadResponse.statusText,
        );
      }
    } catch (error) {
      console.error("Error during upload:", error);
    }
  };

  return (
    // <div style={{ display: "flex", justifyContent: "center" }}>
    //   <Button
    //     onClick={() => setTradeModalVisible(true)}
    //     style={{
    //       display: "flex",
    //       alignItems: "center",
    //       justifyContent: "center",
    //       gap: "1rem",
    //       padding: "1.5rem",
    //       width: "17rem",
    //     }}
    //   >
    //     <FaPlus />
    //     Add Inventory
    //   </Button>
    //   <Modal
    //     title="Add Trading Inventory"
    //     visible={tradeModalVisible}
    //     onOk={handleTradeOk}
    //     onCancel={handleTradeCancel}
    //     width={1200}
    //   >
    //     <div>
    //       <div
    //         style={{
    //           display: "flex",
    //           justifyContent: "center",
    //           alignItems: "center",
    //           marginBottom: "1rem",
    //         }}
    //       >
    //         <div style={{ marginRight: "10px" }}>
    //           <Upload showUploadList={false} onChange={handleExcelUpload}>
    //             <Button icon={<UploadOutlined />}>Upload Excel</Button>
    //           </Upload>
    //           {excelFile && (
    //             <div
    //               style={{
    //                 display: "flex",
    //                 alignItems: "center",
    //                 marginTop: "0.5rem",
    //               }}
    //             >
    //               <p>{excelFile.name}</p>
    //               <Button
    //                 type="text"
    //                 icon={<DeleteOutlined />}
    //                 onClick={handleExcelDelete}
    //                 style={{ marginLeft: "0.5rem" }}
    //               />
    //             </div>
    //           )}
    //         </div>
    //         <div>
    //           <Upload showUploadList={false} onChange={handlePPTUpload}>
    //             <Button icon={<UploadOutlined />}>Upload PPT</Button>
    //           </Upload>
    //           {pptFile && (
    //             <div
    //               style={{
    //                 display: "flex",
    //                 alignItems: "center",
    //                 marginTop: "0.5rem",
    //               }}
    //             >
    //               <p>{pptFile.name}</p>
    //               <Button
    //                 type="text"
    //                 icon={<DeleteOutlined />}
    //                 onClick={handlePPTDelete}
    //                 style={{ marginLeft: "0.5rem" }}
    //               />
    //             </div>
    //           )}
    //         </div>
    //       </div>
    //       {excelData.length > 0 && (
    //         <div style={{ marginTop: "1rem" }}>
    //           <Table columns={columns} dataSource={excelData.slice(1)} />
    //         </div>
    //       )}
    //     </div>
    //   </Modal>
    // </div>

    <>
      {/* <Card
        bordered={true}
        style={{
          margin: "20px",
          padding: "20px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <Typography>
          <Title level={3}>How to Use The Bulk feature</Title>
          <Paragraph>
            Follow this step to add any Trading inventory of any vendor
          </Paragraph>
          <Paragraph>
            <Text strong>Step 1:</Text> Select the trader
          </Paragraph>
          <Paragraph>
            <Text strong>Step 2:</Text> <Text strong>Upload Excel</Text> Filter
            your excel file And remove <Text code>Terms and condition </Text>{" "}
            and <Text code>Availability</Text> Column
          </Paragraph>
          <Paragraph>
            <Text strong>Step 3:</Text> <Text strong>Upload PPT</Text> Remove
            all the extra pages from the ppt like their T&C page etc, there must
            be only slides which contains the the Image with location
          </Paragraph>
          <Paragraph>
            <Text strong>Step 4:</Text> Here are the sample files for uploading
            the excel and ppt{" "}
            <Text strong>
              <a
                target="_blank"
                href="https://drive.google.com/drive/folders/13DHE80ddzrSLr5wnHItIRCy13hilo22E?usp=sharing"
              >
                Click here
              </a>
            </Text>
          </Paragraph>
          <Paragraph>
            If you encounter any issues, contact support for assistance.
          </Paragraph>
        </Typography>
      </Card> */}
      {/* Upload Trading Inventory in bulk — commented out */}
      {false && (
        <>
          <br />
          <h6 style={{ textAlign: "center" }}>
            Upload Trading Inventory in bulk
          </h6>
          <br />
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <div
                style={{
                  marginRight: "200px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div>
                  {options.length > 0 && (
                    <>
                      {console.log("done with this", optionMedia)}
                      <Select
                        disabled={excelData.length > 0 ? false : true}
                        key={selectedValue + "-1"}
                        placeholder="Select an option"
                        // value={selectedValue}
                        onChange={handleFilterChange}
                        style={{ width: 200 }}
                        mode="multiple"
                      >
                        {options.map((option) => (
                          <Option key={option.value} value={option.value}>
                            {option.label}
                          </Option>
                        ))}
                      </Select>
                    </>
                  )}
                </div>
                <div style={{ margin: "0px 10px" }}>
                  {optionMedia.length > 0 && (
                    <Select
                      disabled={excelData.length > 0 ? false : true}
                      key={selectedValue + "-2"}
                      placeholder="Select an option"
                      style={{ width: 200 }}
                      mode="multiple"
                      onChange={handleFiltereeChange}
                    >
                      {optionMedia &&
                        optionMedia.map((option) => (
                          <Option key={option.value} value={option.value}>
                            {option.label}
                          </Option>
                        ))}
                    </Select>
                  )}
                </div>

                <Select
                  value={value}
                  onChange={handleChange}
                  style={{ width: 200 }}
                  placeholder="Select Vendor"
                  allowClear
                >
                  <Option value="chitra">Chitra</Option>
                  {/* <Option value="Myntra">Myntra</Option> */}
                  <Option value="kaushik">Kaushik</Option>
                  <Option value="sun">Sun outdoor</Option>
                  <Option value="evergreen">Ever green</Option>
                  <Option value="mantra">Mantra</Option>
                  <Option value="shah">Shah</Option>
                  <Option value="sitemax">Site max</Option>
                  <Option value="priya">Priya</Option>
                  <Option value="saket">Saket</Option>
                  <Option value="abhik">Abhik</Option>
                  <Option value="others">Others</Option>
                  {/* <Option value="shubham">Shubham</Option>
              <Option value="aim">Aim Communication</Option> */}
                </Select>
              </div>
              <div style={{ marginRight: "10px" }}>
                <Upload
                  showUploadList={false}
                  onChange={handleExcelUpload}
                  disabled={isFirstButtonDisabled}
                >
                  <Button
                    icon={<UploadOutlined />}
                    disabled={isFirstButtonDisabled}
                  >
                    Upload Excel
                  </Button>
                </Upload>
                {excelFile && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "0.5rem",
                    }}
                  >
                    <p>{excelFile.name}</p>
                    <Button
                      type="text"
                      icon={<DeleteOutlined />}
                      onClick={handleExcelDelete}
                      style={{ marginLeft: "0.5rem" }}
                    />
                  </div>
                )}
              </div>
              <div>
                <Upload showUploadList={false} onChange={handlePPTUploadFInal}>
                  <Button
                    icon={<UploadOutlined />}
                    disabled={excelData.length > 0 ? false : true}
                  >
                    Upload PPT
                  </Button>
                </Upload>
                {pptFile && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "0.5rem",
                    }}
                  >
                    <p>{pptFile.name}</p>
                    <Button
                      type="text"
                      icon={<DeleteOutlined />}
                      onClick={handlePPTDelete}
                      style={{ marginLeft: "0.5rem" }}
                    />
                  </div>
                )}
              </div>
            </div>
            {makeInfo && (
              <Alert
                message="As you have selected Others"
                description={
                  <>
                    You have to Input the Excel file in particular headers only.
                    Please refer to the &nbsp;
                    <a
                      href="https://prepseed.s3.ap-south-1.amazonaws.com/Others+(6).xlsx"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      excel file
                    </a>
                    &nbsp; for more details.
                  </>
                }
                type="info"
                showIcon
              />
            )}
            {excelData.length > 0 && (
              <div style={{ marginTop: "1rem" }} id="TableData">
                {/* <Table
              columns={columns}
              dataSource={excelData.slice(1).map((row, index) => ({
                key: index,
                ...row.reduce((acc, value, colIndex) => {
                  acc[colIndex] = value;
                  return acc;
                }, {}),
              }))}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '50'],

              }}
            /> */}
                {isUploading && (
                  <>
                    <MutatingDots
                      visible={true}
                      height="100"
                      width="100"
                      color="#f5d442"
                      secondaryColor="#f5d442"
                      radius="12.5"
                      ariaLabel="mutating-dots-loading"
                      wrapperStyle={{
                        position: "fixed",
                        zIndex: 555,
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        top: 0,
                        left: 0,
                        right: 0,
                      }}
                      wrapperClass=""
                    />
                    <div className="LoaderOverlay"></div>
                  </>
                )}
                <Table
                  columns={columns}
                  dataSource={
                    filteredData.length === 0
                      ? excelData.slice(1)
                      : filteredData.slice(1)
                  }
                  rowKey={(record) => record[0]}
                  pagination={{
                    current: current,
                    pageSize: pageSize,
                    showSizeChanger: true,
                    defaultPageSize: 50,
                    pageSizeOptions: ["10", "20", "50", "100"],
                  }}
                  onChange={handleTableChange}
                  // scroll={{ x: 'max-content' }}
                  style={{ fontSize: "15px" }}
                />

                <Button onClick={handleFilter} style={{ marginBottom: "10px" }}>
                  Show Checked Rows
                </Button>
                <Button
                  onClick={handleRefresh}
                  style={{ marginBottom: "10px", marginLeft: "10px" }}
                >
                  Refresh
                </Button>
              </div>
            )}
          </div>

          <div style={{ marginLeft: "87.5%", marginTop: "10px" }}>
            <Button
              type="primary"
              style={{ margin: "10px" }}
              onClick={handleButtonClick}
              disabled={!value || isFirstButtonDisabled}
            >
              Add in Bulk
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default Trade;
